import { useState } from "react";
import type { WorkReview } from "@/types/work";

interface Props {
  reviews: WorkReview[];
}

export default function ReviewSection({ reviews }: Props) {
  const [expanded, setExpanded] = useState<number | null>(0);

  if (reviews.length === 0) {
    return (
      <section>
        <h2 className="font-heading font-bold text-xl text-foreground-950 mb-4">影评精选</h2>
        <div className="rounded-lg border border-dashed border-background-300 bg-background-100/50 py-10 text-center text-sm text-foreground-500">
          该作品暂无影评，欢迎稍后回来查看。
        </div>
      </section>
    );
  }

  return (
    <section>
      <h2 className="font-heading font-bold text-xl text-foreground-950 mb-4">
        影评精选 <span className="text-sm font-normal text-foreground-500">({reviews.length})</span>
      </h2>
      <div className="flex flex-col gap-3">
        {reviews.map((review, index) => {
          const isOpen = expanded === index;
          return (
            <article
              key={`${review.author}-${index}`}
              className="rounded-lg border border-background-200 bg-background-100/50 p-4 md:p-5"
            >
              <div className="flex items-center gap-3 mb-3">
                <span className="w-9 h-9 flex items-center justify-center rounded-full bg-primary-100 text-primary-700 font-heading font-semibold">
                  {review.author.slice(0, 1)}
                </span>
                <div>
                  <p className="text-sm font-medium text-foreground-900">{review.author}</p>
                  <p className="text-xs text-foreground-500">{review.date}</p>
                </div>
              </div>
              <p
                className={`text-sm text-foreground-700 leading-relaxed ${
                  isOpen ? "" : "line-clamp-3"
                }`}
              >
                {review.content}
              </p>
              <button
                type="button"
                onClick={() => setExpanded(isOpen ? null : index)}
                className="mt-3 text-xs text-accent-600 hover:text-accent-700 flex items-center gap-1 cursor-pointer whitespace-nowrap"
              >
                {isOpen ? "收起全文" : "展开全文"}
                <i className={isOpen ? "ri-arrow-up-s-line" : "ri-arrow-down-s-line"} />
              </button>
            </article>
          );
        })}
      </div>
    </section>
  );
}